const facebookLink = "https://www.facebook.com/groups/115148611899902/";
const instagramLink = "https://www.instagram.com/porvoon_kendoseura/";
const youtubeLink =
  "https://www.youtube.com/playlist?list=PLr5sqJ7KfWOUSxQc2oT_c8vvyKwWLeiR6";
const whatsappLink = "https://chat.whatsapp.com/Jxy0IPm0KFx8QnB4F53jQq";

export const darkenNavBar = function () {
  const nav = document.querySelector(".navbar");
  document.addEventListener("scroll", () => {
    if (window.scrollY < 50) {
      // nav.classList.remove("navbar-dark");
      nav.classList.remove("bg-dark");
    } else {
      // nav.classList.add("navbar-dark");
      nav.classList.add("bg-dark");
    }
  });
  // nav.classList.add("navbar-dark");
  nav.classList.add("bg-dark");
};

// export async function loadNavBar() {
//   return await fetch("/navbar.html")
//     .then((res) => res.text())
//     .then((html) => {
//       document.querySelector(".navbar").innerHTML = html;
//       return true; // resolves only after injection
//     });
// }

// export async function loadFooter() {
//   return await fetch("/footer.html")
//     .then((response) => response.text())
//     .then((result) => {
//       document.querySelector(".footer").innerHTML = result;
//       return true;
//     });
// }

export async function loadNavBar() {
  const url = new URL("../public/navbar.html", import.meta.url); // or fetch("/navbar.html") if using public/
  const res = await fetch(url);
  const html = await res.text();

  // 🛡 Guard here
  if (/<!doctype html/i.test(html)) {
    console.error(
      "Fetched index.html fallback instead of navbar.html. Check path/bundler."
    );
    return;
  }

  document.querySelector(".navbar").innerHTML = html;
  return true;
}

export async function loadFooter() {
  const url = new URL("../public/footer.html", import.meta.url);
  const res = await fetch(url);
  const html = await res.text();

  // 🛡 Guard here too
  if (/<!doctype html/i.test(html)) {
    console.error(
      "Fetched index.html fallback instead of footer.html. Check path/bundler."
    );
    return;
  }

  document.querySelector(".footer").innerHTML = html;
}

export const footerElements = {
  footer: {
    businessId: "footer-businessId",
    chairPerson: "footer-chairPerson",
    currentChair: "footer-currentChair",
    communication: "footer-communication",
    group: "footer-group",
    followUs: "footer-followUs",
    fkaMember: "footer-fkaMember",
  },
};

export const setupNavBarLinks = function () {
  const navbarLinks = document.querySelectorAll(".nav-link");
  const navbarMainPageLink = document.querySelector("#link-mainpage");
  const navbarMemberPageLink = document.querySelector("#link-memberpage");
  const navbarInfoPageLink = document.querySelector("#link-infopage");
  const navbarSocialLinks = document.querySelector(".navbar-social");
  const footerSocialLinks = document.querySelector(".footer-social");
  const footerDirectWhatsappLink = document.querySelector(
    "#footer-whatsapp_separate_link"
  );

  navbarLinks.forEach((link) => {
    link.classList.remove("active");
  });

  const page = window.location.pathname;
  if (page.includes("index")) navbarMainPageLink.classList.add("active");
  if (page.includes("member")) navbarMemberPageLink.classList.add("active");
  if (page.includes("info")) navbarInfoPageLink.classList.add("active");

  navbarMainPageLink.addEventListener("click", () => {
    window.open("/index.html", "_self");
  });

  navbarMemberPageLink.addEventListener("click", () => {
    window.open("/member.html", "_self");
  });

  navbarInfoPageLink.addEventListener("click", () => {
    window.open("/kendo_info.html", "_self");
  });

  navbarSocialLinks.addEventListener("click", (e) => {
    e.preventDefault();
    const tag = e.target.closest("a");
    // console.log("Navbar social clicked");
    if (tag.classList.contains("link-social-whatsapp")) {
      window.open(whatsappLink, "_blank");
    }
    if (tag.classList.contains("link-social-facebook")) {
      window.open(facebookLink, "_blank");
    }
    if (tag.classList.contains("link-social-instagram")) {
      window.open(instagramLink, "_blank");
    }
    if (tag.classList.contains("link-social-youtube")) {
      window.open(youtubeLink, "_blank");
    }
  });

  footerSocialLinks.addEventListener("click", (e) => {
    e.preventDefault();
    const tag = e.target.closest("a");

    // console.log("Footer social clicked");
    if (tag.classList.contains("link-social-whatsapp")) {
      window.open(whatsappLink, "_blank");
    }
    if (tag.classList.contains("link-social-facebook")) {
      window.open(facebookLink, "_blank");
    }
    if (tag.classList.contains("link-social-instagram")) {
      window.open(instagramLink, "_blank");
    }
    if (tag.classList.contains("link-social-youtube")) {
      window.open(youtubeLink, "_blank");
    }
  });

  footerDirectWhatsappLink.addEventListener("click", (e) => {
    e.preventDefault();
    window.open(whatsappLink, "_blank");
  });
};

export const loadDefaultLanguage = function () {
  let language = localStorage.getItem("setLanguage");
  if (!language) {
    // console.log(`Identified navigator language as ${navigator.language}`);
    if (navigator.language.includes("fi")) {
      language = "fi";
      // console.log("Setting default language to Finnish");
    }
    if (navigator.language.includes("sv")) {
      language = "sv";
      // console.log("Setting default language to Swedish");
    }
    if (navigator.language.includes("en")) {
      language = "en";
      // console.log("Setting default language to English");
    }
    if (!language) language = "fi";
    localStorage.setItem("setLanguage", language);
  }

  // if (language) console.log(`Language set to ${language}`);
  return language;
};

export const setLanguage = function (lang) {
  if (["fi", "sv", "en"].includes(lang)) {
    localStorage.setItem("setLanguage", lang);
  } else {
    console.error(`Language ${lang} is not supported`);
  }
};
